import React from 'react';
import Svg, { Path, Circle } from 'react-native-svg';
import { CustomIconProps } from './types';

export const AutoIncrease: React.FC<Omit<CustomIconProps, 'fill'>> = ({
  width = 38,
  height = 38,
  ...props
}) => (
  <Svg width={width} height={height} viewBox="0 0 38 38" fill="none" {...props}>
    <Circle cx="18.7164" cy="18.7164" r="18.7164" fill="#FE7800" />
    <Path
      d="M21.2683 22.4453C18.4502 24.5754 14.5971 24.0064 12.4803 21.4059C10.4269 18.8827 10.619 15.1975 12.9292 12.9082C15.2518 10.6074 18.9278 10.4356 21.4305 12.4994C24.0198 14.6348 24.561 18.4708 22.423 21.2957C22.5109 21.369 22.6111 21.4402 22.6967 21.5255C23.8227 22.6478 24.947 23.7717 26.0703 24.8967C26.4866 25.3135 26.4713 25.8888 26.0383 26.2101C25.698 26.4628 25.2567 26.4199 24.9237 26.0929C24.5717 25.7477 24.226 25.3964 23.8773 25.0475C23.0471 24.2172 22.2168 23.3865 21.3862 22.5565C21.3479 22.5183 21.307 22.4816 21.2683 22.4453ZM12.7098 17.4084C12.7154 19.9936 14.8289 22.1038 17.4085 22.0994C19.9922 22.0951 22.1049 19.979 22.0999 17.4005C22.0949 14.8169 19.9792 12.7051 17.4005 12.7101C14.8155 12.7151 12.7041 14.8296 12.7098 17.4084Z"
      fill="white"
    />
  </Svg>
);


